import React from 'react';

import './mapDrawerLayers.css';

const MapDrawerLayersMainHeader = () => {
  return <div styleName="main-header">Map Layers</div>;
};

export default MapDrawerLayersMainHeader;
